import { createContext, useCallback, useState } from "react";

export const NotificationContext = createContext({
  notification: null,
  addNotification: () => {},
  removeNotification: () => {},
});

export default function NotificationProvider({children}) {
  const [notification, setNotification] = useState(null);

  const addNotification = ({ title, message, type }) => {
    setNotification({title, message, type})
  }

  const removeNotification = () => setNotification(null);

  const contextValue = {
    notification,
    addNotification: useCallback(
      ({ title, message, type }) => {
        addNotification({ title, message, type })
      },[]),
    removeNotification: useCallback(
      () => {
        removeNotification();
      },
      [],
    )
  }

  return <NotificationContext.Provider value={contextValue}>
    {children}
  </NotificationContext.Provider>
 }